// External links for pages whic hare not implemented by microfrontends
export const topDealsLink = "/top-deals";
export const advisorLink = "/ratgeber";
export const offerElectricityLink = "/tarifoptimierung?categoryType=ELECTRICITY";
export const offerGasLink = "/tarifoptimierung?categoryType=GAS";
export const changeServiceElectricityLink = "/wechselservice/strom/abschließen";
export const changeServiceBusinessElectricityLink = "/wechselservice/strom/abschließen?objectType=company";
export const changeServiceGasLink = "/wechselservice/gas/abschließen";
export const changeServiceBusinessGasLink = "/wechselservice/gas/abschließen?objectType=company";
export const createReminderLink = "/erinnerung-erstellen/kategorie";
export const faqLink = "/fragen-und-antworten";
export const contactLink = "/kontakt";
export const companyLink = "/unternehmen";
export const jobsLink = "/unternehmen/jobs";
export const imprintLink = "/internal/impressum";
export const dataprivacyLink = "/internal/datenschutzerklaerung";
export const mediaLink = "/presse";
export const becomePartnerLink = "/partner-werden";
